import React from "react"
import Container from "../components/container"
import * as importantMsgStyles from "./important-msg.module.css"

export default function ImportantMsg() {
    
    const lnk1 = "price-list-editable-forms-6-3-2026-EDITABLE.pdf";
    
    return (
        <section className={importantMsgStyles.important}>
            <Container>
                    <p className={importantMsgStyles.importanttxt}>Please See Our NEW <a className={importantMsgStyles.importantlink} href={lnk1} download>2026 Forensic Product Price List</a> and Visit us at <a className={importantMsgStyles.importantlink} href="https://isfg2026.ca/" target="_blank" rel="noopener noreferrer">ISFG 2026</a> and <a className={importantMsgStyles.importantlink} href="https://web.cvent.com/event/bad96bf3-5957-44b4-8ce6-2adee68c773d/summary" target="_blank" rel="noopener noreferrer">MAFS 2026.</a></p>
            </Container>
        </section>
    )
}
